import React from 'react';
export function SEOContent() {
  return <section className="py-20 bg-white border-t border-warmBorder" data-id="element-999">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1000">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-1001">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-1002">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-1003">
              Switchplates You're Sure to Love!
            </h2>

            <div className="space-y-8 text-warmGray leading-relaxed text-lg" data-id="element-1004">
              <p data-id="element-1005">
                Delightful decorative switchplates, all handmade in the USA, are
                what you will find here at Switchplate Gallery. We have compiled
                an extensive collection of beautiful, tasteful designs for light
                switch plates that blend perfectly with your decor. Hundreds of
                designs by America's favorite artists have been used to turn
                ordinary switch plates into charming works of art.
              </p>

              <p data-id="element-1006">
                Whatever your decorating theme — tropical or beach, wine or
                Parisian, wildlife or horses, music or golf — contemporary,
                traditional, country, southwestern or eclectic — we have
                switchplates that will ultimately be your favorite decorating
                tool. A very small item, with a very big impact!
              </p>

              <hr className="border-warmBorder my-8" data-id="element-1007" />

              <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-1008">
                The Perfect Gift for Everyone
              </h3>
              <p data-id="element-1009">
                Decorative light switch plate covers are great for housewarming
                gifts and also a clever gift for collectors. Know anyone into
                Coca Cola, lighthouses, fishing, fashion, elephants, Santas,
                snowmen, trains or vintage cars? They'd love a light switch to
                match! We have lots of designs for cat lovers, golf nuts, and
                kids, too!
              </p>

              <hr className="border-warmBorder my-8" data-id="element-1010" />

              <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-1011">
                Every Size You Could Possibly Need
              </h3>
              <p data-id="element-1012">
                You can get decorative light switch plates in larger sizes with
                four switches — commonly called quads. We even make both five
                gang and six gang switches (six gang by special order only). Of
                course we have regular triples and doubles, or just a little
                single switch! If you need a switch and a plug together, we have
                those — and those wide switches called decora switches, rockers,
                or GFI's. You can see the many sizes of switchplates available
                by using the{' '}
                <a href="/size-chart" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-1013">
                  Size Chart
                </a>{' '}
                tab above.
              </p>

              <p data-id="element-1014">
                If you don't see what you need there, see our{' '}
                <a href="/special-order-sizes" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-1015">
                  Special Order size chart
                </a>{' '}
                where you will find many more unusual sizes such as blanks,
                switches with blank, plugs with blank, and more — or call{' '}
                <a href="tel:8004976946" className="text-gold hover:text-gold-dark font-bold transition-colors" data-id="element-1016">
                  800.497.6946
                </a>{' '}
                during our regular business hours of 9AM–5PM (EST). We would
                love to help you get the size you need in a design that you'll
                love!
              </p>

              <hr className="border-warmBorder my-8" data-id="element-1017" />

              <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-1018">
                The Switchplate Gallery Difference
              </h3>
              <p data-id="element-1019">
                Light switchplates are little things that can be a lot of fun...
                when you get them from Switchplate Gallery! Every switchplate we
                sell ships with carefully matched, hand painted screws — because
                we believe the details matter. Our products are handmade with
                care, carefully inspected, and securely packaged to arrive in
                perfect condition.
              </p>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-1020">
            <div className="bg-cream p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-1021">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-1022">
                Quick Links
              </h4>
              <ul className="space-y-4" data-id="element-1023">
                <li data-id="element-1024">
                  <a href="/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-1025">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-1026"></span>
                    Size Chart & Measuring Guide
                  </a>
                </li>
                <li data-id="element-1027">
                  <a href="#/custom-orders" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-1028">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-1029"></span>
                    Custom & Special Orders
                  </a>
                </li>
                <li data-id="element-1030">
                  <a href="/faq" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-1031">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-1032"></span>
                    FAQ & "How To" Info
                  </a>
                </li>
                <li data-id="element-1033">
                  <a href="/contact" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-1034">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-1035"></span>
                    Contact Customer Service
                  </a>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-1036">
                <p className="text-sm text-warmGray mb-2 uppercase tracking-wider font-bold" data-id="element-1037">
                  Need assistance?
                </p>
                <a href="tel:8004976946" className="text-2xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-1038">
                  800.497.6946
                </a>
                <p className="text-xs text-warmGray mt-1" data-id="element-1039">
                  Available 9AM–5PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}